module.exports = __webpack_public_path__ + "img/root01.4aed6159.png";